<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-6 col-7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 d-none d-md-inline-block">
          <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col">
          <!-- HTML5 inputs -->
            <div class="card">
              <!-- Card header -->
              <div class="card-header">
                <h3 class="mb-0">Estos campos se reflejarán en la aplicación</h3>
              </div>
              <!-- Card body -->
              <div class="card-body form_laive validateClient">
                <div class="box_loader">
                  <div class="loader"></div>
                </div>
                <!-- <pre>{{model}}</pre> -->
                <form @submit.prevent="submitConnection">
                  <div class="row">
                    <label class="col-md-12 col-form-label form-control-label"
                      >Tiempo de intento de reconexión.</label
                    >
                    <div class="col-md-12">
                      <base-input
                        required
                        name="tiempo_reintento"
                        placeholder="Indicar el tiempo"
                        v-model="tiempo_reintento.valor"
                        @keypress="isNumber($event)"
                      ></base-input>
                    </div>
                  </div>
                  <base-button type="primary" native-type="submit" class="btn-default my-0"
                    >Actualizar tiempo de reconexión</base-button>
                </form>
              </div>
              <div class="card-body form_laive validateClient">
                <div class="box_loader">
                  <div class="loader"></div>
                </div>
                <form @submit.prevent="submitSession">
                  <div class="row">
                    <label
                      for="example-search-input"
                      class="col-md-12 col-form-label form-control-label"
                      >Tiempo de sesión abierta en la aplicación</label
                    >
                    <div class="col-md-12">
                      <base-input
                        required
                        name="tiempo_sesion_app"
                        id="example-search-input"
                        placeholder="Indicar tiempo de sesión"
                        v-model="tiempo_sesion_app.valor"
                        @keypress="isNumber($event)"
                      >
                        <template v-slot:addonLeft>Min.</template>
                      </base-input>
                    </div>
                  </div>
                  <base-button type="primary" native-type="submit" class="btn-default my-0">Actualizar tiempo de sessión</base-button>
                </form>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";
  import { useToast } from "vue-toastification";
  import Notification from "@/components/Notification";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import DashboardNavbar from "../Layout/DashboardNavbar";
  export default {
    components: {
      DashboardNavbar,
      RouteBreadCrumb,
    },
    created(){
      const $this = this;
      const token = localStorage.getItem("token")
      const config = {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };
      const urlApiParameters = process.env.VUE_APP_API_URL+"/parametro/lista"
      axios.post(urlApiParameters,"",config)
      .then(function (response){
        const data = response.data;
        // Reintento de reconexión
        let tiempo_reintento = data.filter((item)=>{return item.codigoParametro == "tiempo_reintento"})
        $this.tiempo_reintento.idParametro = tiempo_reintento[0].idParametro
        $this.tiempo_reintento.codigoParametro = tiempo_reintento[0].codigoParametro
        $this.tiempo_reintento.valor = tiempo_reintento[0].valor
        // Tiempo de Sesión abierta
        let tiempo_sesion_app = data.filter((item)=>{return item.codigoParametro == "tiempo_sesion_app"})
        $this.tiempo_sesion_app.idParametro = tiempo_sesion_app[0].idParametro
        $this.tiempo_sesion_app.codigoParametro = tiempo_sesion_app[0].codigoParametro
        $this.tiempo_sesion_app.valor = tiempo_sesion_app[0].valor
        const getFormsLaive = document.querySelectorAll(".form_laive")
        getFormsLaive.forEach(element => {
          element.classList.remove("validateClient")
        });
      })
    },
    methods: {
      isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
      submitConnection(evn) {
        const $parent = evn.target.parentNode;
        const token = localStorage.getItem("token")
        const config = {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        };
        const dataSend = this.tiempo_reintento
        const urlApiUpdated = process.env.VUE_APP_API_URL+"/parametro/actualizar"
        $parent.classList.add("validateClient")
        axios.put(urlApiUpdated,dataSend,config)
        .then(function (response){
          $parent.classList.remove("validateClient")
          const text = (response.status == 200) ? "Se actualizó el Intento de Reconexión" : "Hubo un error";
          const icon = "ni ni-bell-55";
          const content = {
            component: Notification,
            props: {
              icon: icon,
              text: text,
              type: (response.status == 200) ? "success" : "danger",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
        })
      },
      submitSession(evn) {
        const $parent = evn.target.parentNode;
        const token = localStorage.getItem("token")
        const config = {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        };
        const dataSend = this.tiempo_sesion_app
        const urlApiUpdated = process.env.VUE_APP_API_URL+"/parametro/actualizar"
        $parent.classList.add("validateClient")
        axios.put(urlApiUpdated,dataSend,config)
        .then(function (response){
          $parent.classList.remove("validateClient")
          const text = (response.status == 200) ? "Se actualizó el Tiempo de Sesion abierta" : "Hubo un error";
          const icon = "ni ni-bell-55";
          const content = {
            component: Notification,
            props: {
              icon: icon,
              text: text,
              type: (response.status == 200) ? "success" : "danger",
            },
          };
          const toast = useToast();
          toast(content, {
            hideProgressBar: true,
            icon: false,
            closeButton: false,
            position: "top-right",
          });
        })
      }
    },
    data() {
      return {
        tiempo_reintento: {
          idParametro: "",
          codigoParametro: "",
          valor: ""
        },
        tiempo_sesion_app: {
          idParametro: "",
          codigoParametro: "",
          valor: ""
        },
        model: {
          time: "",
          session: "",
        },
      };
    },
  };
</script>

